import { Search as SearchIcon } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface IPageHeaderMobileSearchButtonProps {
  isAnyFilterActive: boolean;
  onClick: () => void;
}

export const PageHeaderMobileSearchButton: FC<
  IPageHeaderMobileSearchButtonProps
> = ({ isAnyFilterActive, onClick }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={onClick}
      className="filter-apply-button"
      aria-label={t("general.SEARCH")}
    >
      {/* The dot stands in for the old filled funnel: a search or filter is applied. */}
      <Badge color="primary" variant="dot" invisible={!isAnyFilterActive}>
        <SearchIcon color="primary" />
      </Badge>
    </IconButton>
  );
};
